<template>
  <div>
    <div>
      <div v-if="!showSearch" class="div-btn side-by-side">
        <Button _key="btnShow" color="black" backGroundColor="#F0F0F0"
          :title="' ' + quantitySelected + ' ' + title + ' selecionado(s)'"
          classIcon="fa-sharp fa-solid fa-ballot-check" size="small" :clicked="showHide" />
      </div>
      <div v-show="show" class="side-by-side">
        <div class="input-container">
          <input type="text" v-model="baseParams.search" placeholder="Pesquisar..." @keyup.enter.prevent="getAll" />
          <Button _key="btnSearch" :disabled="baseParams.search == ''" type="info"
            classIcon="fa-solid fa-magnifying-glass" size="small" :clicked="getAll" />
          <Button _key="btnClean" :disabled="baseParams.search == ''" type="info" classIcon="fa-solid fa-broom"
            size="small" :clicked="clean" />
        </div>
      </div>

    </div>
    <div v-show="show">
      <div class="div-loading">
        <Loading type="line" :center="false" v-show="loading" />
      </div>
      <ScrollBar :minHeight="0" :maxHeight="200">
        <div v-if="multipleSelection" class="div-check">
          <div class="div-items" v-for="item in data" :key="item.id">
            <b-form-checkbox v-model="item.selected" @change="add(item)">
              <span class="title" :title="item.content">{{ item.content }}</span>
            </b-form-checkbox>
          </div>
        </div>
        <div v-else class="div-check">
          <b-form-group>
            <b-form-radio-group v-model="selected" :options="options" :stacked="true"></b-form-radio-group>
          </b-form-group>
        </div>
        <div v-if="totalRecords > 20 && data.length < totalRecords">
          <div class="after-list text-center">
            <Button key="loadingMore" type="info" title="Carregar mais..." size="small" :clicked="loadingMore" />
          </div>
        </div>
        <div class="title" v-if="data.length == 0">
          Nenhum registro encontrado!
        </div>
      </ScrollBar>
    </div>
  </div>
</template>

<script>
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import ScrollBar from "@nixweb/nixloc-ui/src/component/layout/ScrollBar.vue";
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";
import InputText from "@nixweb/nixloc-ui/src/component/forms/InputText";

import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "CheckboxServer",
  components: {
    Button, ScrollBar, Loading, InputText
  },
  props: {
    title: String,
    url: String,
    multipleSelection: {
      type: Boolean,
      default: true
    },
    showSearch: {
      type: Boolean,
      default: false
    },
    propsParams: Object,
    value: Array,
    changed: Function,
  },
  data() {
    return {
      show: false,
      loading: true,
      data: [],
      selected: [],
      totalRecords: 0,
      baseParams: {
        search: "",
        currentPage: 1,
        totalPerPage: 50,
      },
    };
  },
  mounted() {
    this.getAll();
    if (this.showSearch) this.showHide();
    if (this.value.length > 0) {
      this.selected = this.value;
    }
  },
  computed: {
    ...mapGetters("generic", ["showModal", "event"]),
    quantitySelected() {
      return this.selected.length > 0 ? this.selected.length : 0;
    },
    options() {
      let final = [];
      this.data.forEach(item => {
        let obj = { text: item.content, value: item.id };
        final.push(obj);
      });
      return final;
    }
  },
  methods: {
    ...mapMutations("generic", ["removeLoading"]),
    ...mapActions("generic", ["getApi"]),
    getAll() {
      let obj = { ...this.baseParams, ...this.propsParams };
      let params = { url: this.url, obj: obj };
      this.loading = true;
      this.getApi(params).then((response) => {
        this.totalRecords = response.content.totalRecords;
        if (this.baseParams.currentPage == 1) {
          this.data = [];
        }

        let self = this;
        response.content.data.forEach(item => {
          self.data.push(item);
        });

        this.markSelected();

        this.loading = false;
        this.removeLoading(["loadingMore", "btnSearch", "btnClean"]);
      });
    },
    loadingMore() {
      this.baseParams.currentPage++;
      this.getAll();
    },
    add(item) {
      const index = this.selected.indexOf(item.id);
      if (index > -1) {
        this.selected.splice(index, 1);
      } else {
        this.selected.push(item.id);
      }
    },
    showHide() {
      this.show = this.show == true ? false : true;
      this.removeLoading(["btnShow"]);
    },
    clean() {
      this.baseParams = {
        search: "",
        currentPage: 1,
        totalPerPage: 50,
      }
      this.getAll();
    },
    markSelected() {
      this.data.forEach(item => {
        if (this.selected.includes(item.id)) {
          item.selected = true;
        }
      });
    }
  },
  watch: {
    selected: {
      handler(value) {
        if (value) {
          this.$emit("input", value);
          if (this.changed) this.changed(value);
        }
      },
      deep: true,
    },
    event: {
      handler(event) {
        if (event.name == "cleanCheckboxServer")
          this.selected = "";
      },
      deep: true,
    },
    'baseParams.search': {
      handler(value) {
        //  this.getAll();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.div-check {
  margin: 10px;
}

.div-items {
  margin-left: 10px;
  max-width: 100%;
}

.div-items ::v-deep .custom-control {
  display: flex;
  align-items: center;
  max-width: 100%;
}

.div-items ::v-deep .custom-control-label {
  min-width: 0;
  flex: 1;
}

.title {
  display: block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.div-loading {
  margin-top: 3px;
}

.div-btn {
  padding-bottom: 5px;
}

.div-icon {
  margin-left: 10px;
  font-size: 16px;
  color: green;
  cursor: pointer;
}

.input-container {
  display: flex;
  justify-content: center;
  margin: 20px;
}

input {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 4px;
  padding-bottom: 4px;
  border: 1px solid #E5E4E8;
  border-radius: 20px;
  outline: none;
  font-size: 13px;
  width: 300px;
}
</style>
